export const UNKNOWN_DIMENSION_TYPE_NAME = '__unknown__';
export type DimensionValueByType = { type: string; value: string | undefined };
export type ColorUiType = 'color tile' | 'image tile' | 'color dropdown';
export type DimensionsStateEvent = {
    dimensionStates: DimensionValueByType[];
    selectedState: DimensionValueByType[];
    dimensionTypeUsed?: ColorUiType | undefined;
    dimensionEnabled?: boolean;
    triggeredByDimensionSelectionSheet?: boolean;
};

export const dimTypeOrder: Record<string, number> = {
    color: 0,
    cover: 1,
    lyingSurface: 2,
    diagonal: 3,
    size: 4,
    width: 5,
    length: 6,
    girth: 7,
    cupSize: 8,
    height: 9,
    plaidSize: 10,
    pillowSize: 11,
    material: 12,
    mounting: 13,
    heatClass: 14,
    adjustmentFunction: 15,
    function: 16,
    temper: 17,
    weightCapacity: 18,
    plaidType: 19,
    quantity: 20,
    quality: 21,
    version: 22,
    usage: 23,
    'cup-size': 24,
    guarantee: 25,
    capacity: 26,
    dimension: 27,
    customLength: 28,
    customWidth: 29,
    retailer: 30,
    supplier: 31,
    form: 32,
    frameHeight: 33,
    knit: 34,
    sleeveLength: 35,
    weight: 36,
    wheelSize: 37,
    unknown: 38,
    [UNKNOWN_DIMENSION_TYPE_NAME]: 39,
};

export function compareDimensionTypes(a: string | undefined, b: string | undefined): number {
    a = a ?? UNKNOWN_DIMENSION_TYPE_NAME;
    b = b ?? UNKNOWN_DIMENSION_TYPE_NAME;
    const orderPositionA = dimTypeOrder[a] ?? dimTypeOrder[UNKNOWN_DIMENSION_TYPE_NAME];
    const orderPositionB = dimTypeOrder[b] ?? dimTypeOrder[UNKNOWN_DIMENSION_TYPE_NAME];
    return orderPositionA - orderPositionB;
}
